import React, { useState } from 'react';
import { mailingAPI } from '../../services/api';

const CONSENT = '我們收集你的電話或電郵，用於會務通訊及直接促銷。你可以隨時取消訂閱。勾選即表示你已閱讀並同意上述用途。';

const MailingSignup = () => {
  const [form, setForm] = useState({ display_name: '', phone_number: '', email: '', consent_given: false });
  const [message, setMessage] = useState('');
  const [token, setToken] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setMessage('');
    try {
      const response = await mailingAPI.signup(form);
      setToken(response.data.unsubscribe_token);
      setMessage('已加入通訊錄');
    } catch (err) {
      const data = err.response?.data;
      setMessage(data?.consent_given || data?.contact || data?.error || '提交失敗');
    }
  };

  return (
    <section className="container" style={{ padding: '2rem 1rem', maxWidth: 640 }}>
      <h1>加入通訊錄</h1>
      <form onSubmit={submit}>
        <label>稱呼
          <input value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} />
        </label>
        <label>電話
          <input value={form.phone_number} onChange={(e) => setForm({ ...form, phone_number: e.target.value })} />
        </label>
        <label>電郵
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </label>
        <label>
          <input type="checkbox" checked={form.consent_given} onChange={(e) => setForm({ ...form, consent_given: e.target.checked })} />
          {' '}{CONSENT}
        </label>
        <button type="submit" className="btn btn-primary">提交</button>
      </form>
      {message && <p>{message}</p>}
      {token && <p>取消訂閱連結：/mailing/unsubscribe/{token}</p>}
    </section>
  );
};

export default MailingSignup;
